import Styles from './NSTitle.module.css';
import { IBaseComponentProps } from "../props/IBaseComponentProps";

export interface NSTitleProps extends IBaseComponentProps
{
	title: string;
}

export function NSTitle(props: NSTitleProps)
{
	return (
		<h2
			id={props.id}
			className={`${Styles.ns_title} ${props.classList?.join(" ") ?? ""}`}
			style={props.style}
		>
			{props.title}
		</h2>
	);
}